import { Grid, Icon } from "@mui/material";
import MDButton from "components/MDButton";
import { useFormikContext } from "formik";
import { useEffect } from "react";
import { useParams } from "react-router-dom";
import { fetchById } from "services/ShowroomSubscriptionPackage";
import { useMaterialUIController, setErrorSB } from "context";
import useLocale from "context/useLocale";
import TextRow from "components/Fields/TextRow";
import CheckboxRow from "components/Fields/CheckboxRow";

function ShowroomSubscriptionPackageFormik() {
  const locale = useLocale();
  const {
    setFieldValue,
    handleSubmit,
    handleChange,
    handleBlur,
    values,
    errors,
    touched,
    isSubmitting,
  } = useFormikContext();
  const { id } = useParams();
  const [, dispatch] = useMaterialUIController();

  useEffect(async () => {
    if (id) {
      await fetchById(id).then(
        (res) => {
          setFieldValue(
            "allowed_featured_listings_count",
            res.data.data.allowed_featured_listings_count
          );
          setFieldValue("allowed_listings_count", res.data.data.allowed_listings_count);
          setFieldValue("can_manage_branches", res.data.data.can_manage_branches);
          setFieldValue("featured_validity_period", res.data.data.featured_validity_period);
          setFieldValue("is_featured_showroom", res.data.data.is_featured_showroom);
          setFieldValue("name", res.data.data.name);
        },
        (err) => setErrorSB(dispatch, `${err.response.data.error.message}`)
      );
    }
  }, []);

  return (
    <form onSubmit={handleSubmit}>
      <Grid container spacing={2}>
        <TextRow
          title={locale("name")}
          code="name"
          value={values.name}
          error={errors.name}
          touched={touched.name}
          handleChange={handleChange}
          handleBlur={handleBlur}
          isRequired
        />

        <Grid item xs={12}>
          <Grid container spacing={2}>
            <TextRow
              title={locale("allowed_listings_count")}
              code="allowed_listings_count"
              value={values.allowed_listings_count}
              error={errors.allowed_listings_count}
              touched={touched.allowed_listings_count}
              handleChange={handleChange}
              handleBlur={handleBlur}
              isRequired
              type="number"
            />
            <TextRow
              title={locale("allowed_featured_listings_count")}
              code="allowed_featured_listings_count"
              value={values.allowed_featured_listings_count}
              error={errors.allowed_featured_listings_count}
              touched={touched.allowed_featured_listings_count}
              handleChange={handleChange}
              handleBlur={handleBlur}
              isRequired
              type="number"
            />
            <TextRow
              title={locale("featured_validity_period")}
              code="featured_validity_period"
              value={values.featured_validity_period}
              error={errors.featured_validity_period}
              touched={touched.featured_validity_period}
              handleChange={handleChange}
              handleBlur={handleBlur}
              isRequired
              type="number"
            />
          </Grid>
        </Grid>
        <Grid item xs={12}>
          <Grid container spacing={2}>
            <CheckboxRow
              title={locale("can_manage_branches")}
              code="can_manage_branches"
              value={values.can_manage_branches}
              error={errors.can_manage_branches}
              touched={touched.can_manage_branches}
              handleChange={handleChange}
              handleBlur={handleBlur}
              isRequired
            />
            <CheckboxRow
              title={locale("is_featured_showroom")}
              code="is_featured_showroom"
              value={values.is_featured_showroom}
              error={errors.is_featured_showroom}
              touched={touched.is_featured_showroom}
              handleChange={handleChange}
              handleBlur={handleBlur}
              isRequired
            />
          </Grid>
        </Grid>
      </Grid>
      <Grid display="flex" justifyContent="flex-end" mt={3}>
        <MDButton
          type="submit"
          variant="contained"
          color="info"
          endIcon={<Icon>send</Icon>}
          disabled={isSubmitting}
        >
          {locale("submit")}
        </MDButton>
      </Grid>
    </form>
  );
}

export default ShowroomSubscriptionPackageFormik;
